import type { NextPage, GetStaticProps, GetStaticPropsContext } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'

import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { usePageTitle } from '~/utils/tags'
import { COMMON_TRANSLATION_MODULE_NAMES, DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import Metatags from '~/components/Metadata/Metatags'
import { Games } from '~/games/pages/Games.page'

const GamesPage: NextPage = () => {
  const { t } = useTranslation('games')
  const pageTitle = usePageTitle(t('title'))

  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} title={pageTitle} />
      <DefaultLayout zeroPadding>
        <Games />
      </DefaultLayout>
    </div>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => ({
  props: {
    ...(await serverSideTranslations(locale as string, [
      ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
      ...COMMON_TRANSLATION_MODULE_NAMES,
      'games',
    ])),
  },
})

export default GamesPage
